import React from "react";
import { BillingsMain } from "../../components/Billings/BillingsMain";
// import { GogetOneBillingCard } from "../../components/Billings/Subscriptions/Products/GogetOneBillingCard";
import { PageHeader } from "../../components/shared/PageHeader/PageHeader";
import { tooltips } from "../../lib/utils/tooltips";

import "./Billings.scss";

export const Billings = () => {
  return (
    <div className="default-page">
      <PageHeader title="Billing" hideBorder message={tooltips.billings} />
      {/* <div className="Billings__featuredProducts">
        <GogetOneBillingCard />
      </div> */}
      <BillingsMain />
    </div>
  );
};
